const paragraphClasses =
'text-gray-800 text-base text-justify leading-relaxed mt-2';
const listClasses =
'text-gray-800 text-base ml-7 leading-relaxed mt-2 list-disc';
const sectionClasses =
'text-purple-500 font-poppins font-bold text-2xl mr-4 mb-6 my-6';
const textAsistensi = <b className="text-pink-500">asistensi</b>;
const linkClass = 'text-gray-800 leading-relaxed font-poppins cursor-pointer font-semibold text-base';

export default [
    {
        title: <>Sobre {textAsistensi}</> ,
        questions : [
            {
                number : '01',
                question : <>¿Qué es {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                    {textAsistensi} es una una compañía que ofrece planes de salud accesibles que incluyen servicios y seguros de calidad que protegen frente a los malestares del día a día, enfermedades comunes y emergencias médicas. 
                </p>
                <p className={paragraphClasses}>
                    Estamos enfocados en apoyar principalmente a quienes han emigrado para que puedan seguir cuidando de sus seres queridos 
                    en sus países de origen sin importar las distancias.
                </p>
                <p className={paragraphClasses}>
                    Nuestra visión es hacer que la salud sea accesible para todos usando el poder de la tecnología. 
                    Para lograrlo, en República Dominicana hemos reunido a las compañías de mayor experiencia del sector en el país. 
                    Los beneficios y servicios de Humano Seguros, ProMed y Laboratorios Amadita forman parte de la propuesta de valor de {textAsistensi} República Dominicana.
                </p>
                <p className={paragraphClasses}>
                    Somos una insurtech global comprometida con la salud de los dominicanos.
                </p>
            </div>
            },
            {
                number : '02',
                question : <>¿Quiénes somos?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        {textAsistensi} está conformado por un equipo multidisciplinario integrado por médicos y profesionales especializados en servicios 
                        asistenciales de salud y seguros médicos. Estamos orientados a mejorar la calidad de vida de nuestros miembros, 
                        buscando todas las soluciones posibles para apoyarlos, sin importar la distancia.
                    </p>
                    <p className={paragraphClasses}>
                        Nuestra misión es empoderar a los migrantes para que sigan adelante con sus vidas con la tranquilidad de que nosotros 
                        cuidamos la salud de los suyos en sus países de origen.
                    </p>
                </div>
            },
            {
                number : '03',
                question : <>¿En qué países tienen presencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Somos una insurtech basada en Madrid y tenemos operaciones en Latinoamérica y el Sudeste Asiático, 
                        desde donde cuidamos a los familiares de los migrantes que residen por todo el mundo.
                    </p>
                    <p className={paragraphClasses}>
                        Nuestros planes y seguros están disponibles para residentes en República Dominicana, México, Venezuela, Honduras, Guatemala y Filipinas. 
                    </p>
                </div>
            },
            {
                number : '04',
                question : <>¿{textAsistensi} es una compañía de seguros?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        {textAsistensi} es una compañía que ofrece planes de salud que protegen frente a emergencias médicas, enfermedades comunes y malestares del día a día; para que los migrantes dominicanos puedan afiliar a sus seres queridos que se encuentran dentro de la República Dominicana. Los planes de salud que ofrece {textAsistensi} tienen válidez y vigencia dentro del territorio de la República Dominicana bajo el amparo de Humano Seguros, la compañía aseguradora de salud líder de República Dominicana.
                    </p>
                </div>
            },
            {
                number : '05',
                question : <>¿Quiénes apoyan nuestra misión y visión?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Contamos con el respaldo de reconocidos inversores institucionales que apoyan nuestra visión y misión y que invierten en el largo plazo de nuestros planes. Entre ellos se encuentran 468 Capital, el fondo alemán de tecnología; Alma Mundi Ventures, el fondo líder en insurtech en Europa; y el fondo líder en México, Nazca.
                    </p>
                </div>
            },
            {
                number : '06',
                question : <>¿Qué empresas de salud y seguro nos apoyan?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Para crear un producto único e incomparable del cual se beneficiarán millones de migrantes dominicanos y sus familiares, hemos reunido a las mejores compañías del sector salud de la República Dominicana para ofrecer lo mejor de estas empresas en un único plan. Contamos con el respaldo de Humano Seguros, Amadita Laboratorio Clínico, PROMED, CEMDOE, Macromédica, Hospital IMG, La Plaza de la Salud, Hospital Metropolitano de Santiago (HOMS), entre otras.
                    </p>
                </div>
            },
            {
                number : '07',
                question : <>¿Cuál es la diferencia entre un seguro convencional y los planes de salud de {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En {textAsistensi} cubrimos condiciones médicas de aparición repentina e inesperada que hayan iniciado en un tiempo no mayor a 72 horas y cuyos síntomas pueden poner en riesgo la vida, requiriendo atención médica inmediata. Además, brindamos protección ante enfermedades comunes y malestares del día a día como dolores de cabeza, procesos gripales, entre otros.
                    </p>
                    <p className={paragraphClasses}>
                    Un seguro de salud convencional incluye otros aspectos de salud como maternidad (parto, cesárea o aborto), enfermedades de aparición más lenta (mayor de 72 horas de inicio) y sin compromiso inmediato a la vida o crónicas, procedimientos electivos/programados, consultas de especialidades médicas, exámenes diagnósticos, trasplantes y medicamentos para enfermedades crónicas (tratamiento de cáncer, etc.).
                    </p>
                </div>
            },
            {
                number : '08',
                question : <>¿Qué nos distingue de otras compañías de seguros?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Gracias a nuestra tecnología propietaria e innovador modelo de admisión de riesgos y reclamos, logramos la inclusión de personas tradicionalmente excluidas de los seguros, mejoramos la experiencia de cliente y le otorgamos importantes ahorros.
                    </p>
                    <p className={paragraphClasses}>
                        A diferencia de otras aseguradoras, {textAsistensi} oferece planes de salud que permiten afiliar a personas con cobertua de hospitalización hasta los 80 años de edad y con preexistencias como la diabetes e hipertensión, lo cual es una transformación fundamental en los planes de salud, ya que hoy en día estas personas están generalmente excluidas por el mercado tradicional.
                    </p>
                    <p className={paragraphClasses}>
                        Todo esto con una experiencia de cliente superior: Canalizamos cualquier atención médica requerida en menos de 20 segundos y el 90% de las atenciones médicas domiciliarias de emergencia son atendidas en menos de 45 minutos.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>Servicios, cobertura y planes {textAsistensi}</> ,
        questions : [
            {
                number: "09",
                question : <>¿Cuáles son los planes que tiene {textAsistensi} y qué incluyen?</>,
                answer: 
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Puedes contratar el plan {textAsistensi} o el plan{' '}
                        {textAsistensi} plus.
                    </p>
                    <p className={paragraphClasses}>
                        El <b className="text-pink-500">plan asistensi</b> incluye:
                    </p>
                    <ul className={listClasses}>
                        <li>
                        Telemedicina ilimitada 24/7 (orientación médica y acompañamiento vía telefónica o por video llamada)
                        </li>
                        <li>Atención médica domiciliaria ilimitada 24/7</li>
                        <li>Traslados en ambulancia ilimitados 24/7</li>
                        <li>Pruebas de laboratorios clínicos (2 perfiles al año)</li>
                        <li>Consultas con especialistas (2 al año)</li>
                        <li>
                        Cobertura para hospitalización y cirugía de emergencia, amparada por Humano Seguros hasta por RD$350,000 por caso, al año.
                        </li>
                    </ul>
                    <p className={paragraphClasses}>
                        El <b className="text-pink-500">plan asistensi plus</b>{' '}
                        incluye:
                    </p>
                    <ul className={listClasses}>
                        <li>
                        Telemedicina ilimitada 24/7 (orientación médica y acompañamiento vía telefónica o por video llamada)
                        </li>
                        <li>Atención médica domiciliaria ilimitada 24/7</li>
                        <li>Traslados en ambulancia ilimitados 24/7</li>
                        <li>Pruebas de laboratorios clínicos (4 perfiles al año)</li>
                        <li>Consultas con especialistas (4 al año)</li>
                        <li>
                        Cobertura para hospitalización y cirugía de emergencia, amparada por Humano Seguros de hasta RD$600,000 por caso, al año
                        </li>
                        <li>Indemnización para enfermedades mayores</li>
                    </ul>
                    <p className={paragraphClasses}>
                        Adicional a estos planes, puedes agregar a tu plan de salud, un plan de medicamentos para emergencias médicas y/o un botón de asistencia.
                    </p>
                </div>
            },
            {
                number : '10',
                question : <>¿Los planes tienen servicios ilimitados? </>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        {textAsistensi} fue diseñado para que uses todos los servicios cuando lo necesites. Por lo tanto, tendrás acceso ilimitado y 24/7 a los servicios de: telemedicina, atención médica domiciliaria, traslados en ambulancias, lectura de exámenes médicos y segunda opinión médica. 
                    </p>
                    <p className={paragraphClasses}>Para los exámenes de laboratorio y consultas con especialistas, tendrás disponible la cantidad de acuerdo al plan escogido; igual que para la cobertura de hospitalización y cirugía de emergencia en clínicas privadas, cubrimos hasta el monto de la cobertura por patología, por año.</p>
                </div>
            },
            {
                number : '11',
                question : <>¿Qué supone la telemedicina y quién brinda este servicio?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Gracias al servicio de telemedicina podrás contactar en menos de 20 segundos con un médico dominicano, siempre que lo necesites y desde cualquier lugar.
                    </p>
                    <p className={paragraphClasses}>
                        Nuestros médicos de cabecera, forman parte del equipo de {textAsistensi} y están disponibles las 24 horas del día, los 365 días del año, sin cita previa, por teléfono o videollamada a través de la App asistensi RD, para orientar ante cualquier situación o duda médica y acompañar durante la solicitud de los servicios de salud del plan {textAsistensi}. 
                    </p>
                    <p className={paragraphClasses}>
                        Además, nuestros doctores proveen un servicio de acompañamiento y tratamiento médico emitiendo recetas, prescribiendo medicamentos y solicitando estudios complementarios.
                    </p>
                    <p className={paragraphClasses}>
                        De ser necesario, también se encargan de gestionar la atención médica domiciliaria, el traslado en ambulancias, y de apoyar en la admisión a centros de salud afiliados activando la cobertura con Humano Seguros.
                    </p>
                </div>
            },
            {
                number : '12',
                question : <>¿El servicio de telemedicina para el titular del plan es ilimitado y funciona en todo el mundo?</>,
                answer :								
                    <div className="flex flex-col px-2">
                        <p className={paragraphClasses}>
                            Sin importar donde se encuentre el titular del plan, con tan solo descargar la App {textAsistensi} RD disponible para iOS y Android, podrá usar el servicio de telemedicina cuando lo necesite. Es importante recalcar que las recetas emitidas por {textAsistensi} República Dominicana tendrán validez únicamente en territorio dominicano. 
                        </p>
                    </div>

                    
            },
            {
                number : '13',
                question : <>¿Cuál es el horario de uso para la telemedicina?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El servicio de telemedicina de asistensi tiene dos vías de comunicación: la primera, conocida como orientación médica telefónica y la segunda, conocida como orientación médica virtual.
                    </p>
                    <p className={paragraphClasses}>
                        La orientación médica telefónica estará disponible y podrá brindarse las 24 horas del días, los 7 días de la semana.
                    </p>
                    <p className={paragraphClasses}>
                        La orientación médica virtual por videollamada a través de la aplicación móvil (APP) asistensi RD, estará operativa de 8:00 a.m. a 10:00 p.m. los 7 días de la semana.
                    </p>
                </div>
            },
            {
                number : '14',
                question : <>¿Qué es la atención médica domiciliaria?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En los casos en que sea necesaria una consulta presencial, nuestros médicos y paramédicos realizan visitas domiciliarias para determinar mejor las necesidades del paciente. El equipo médico podrá hacer un diagnóstico e indicar tratamiento, incluso colocar dosis únicas de medicamentos.
                    </p>
                    <p className={paragraphClasses}>Nuestro servicio de atención médica domiciliaria está disponible las 24 horas, los 365 días del año.</p>
                </div>
            },
            {
                number : '15',
                question : <>¿En qué consiste el servicio de traslados en ambulancia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En caso de urgencia médica y necesitar traslado de emergencia, nuestros doctores coordinarán el envío de ambulancias equipadas con soporte avanzado de vida y con personal altamente calificado.
                        <br/>El número de traslados al año es ilimitado y está disponible las 24 horas del día, los 365 días del año.
                    </p>
                </div>
            },
            {
                number : '16',
                question : <>¿Quién presta el servicio de atención médica domiciliaria y traslados en ambulancias?</>,
                answer :
                    <div className="flex flex-col px-2">
                        <p className={paragraphClasses}>
                            Contamos con la fortuna de tener socios comerciales del calibre de PROMED, SAM Ambulancia, ServiAmbulancias Nacionales y CASALUD, que brindan un servicio de calidad alineado a los estándares de excelencia.
                        </p>
                    </div>
            },
            {
                number : '17',
                question : <>¿Tengo acceso a estudios de laboratorio con un plan de salud {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Para poder recibir un diagnóstico y tratamiento médico óptimo, cuentas con hasta 4 perfiles de laboratorios clínicos al año, los cuales pueden incluir varios estudios y la interpretación de los resultados, siempre y cuando nuestros médicos los consideren necesarios y estén incluidos en el plan. 
                    </p>
                </div>
            },
            {
                number : '18',
                question : <>¿Qué perfiles de laboratorio cubren los planes de salud {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        A raíz de situaciones y condiciones médicas que requieran análisis clínicos que ayuden a validar la orientación ofrecida por los doctores de {textAsistensi}, ponemos a disposición de nuestros beneficiarios, perfiles y pruebas de laboratorio preestablecidos: 
                    </p>
                    <p className={paragraphClasses}>
                        Perfil infección urinaria: Hemograma, urianalisis, creatinina, BUN, cultivo de orina, eritrosedimentación  <br/>
                        Perfil infección básico: Hemograma, glucosa, creatinina, BUN, eritrosedimentación  <br/>
                        Perfil infección enteral: Hemograma, creatinina, BUN, coprológico, eritrosedimentación  <br/>
                        Perfil infección completo: Hemograma, BUN, SGPT, SGOT, PCR, glucosa, creatinina
                    </p>
                    <p className={paragraphClasses}>
                        Adicionalmente y en caso de requerirlo, ofrecemos a todos nuestros beneficiarios la lectura de cualquier estudio de laboratorio, sea o no un un perfil o prueba preestablecida por {textAsistensi}.
                    </p>
                </div>
            },
            {
                number : '19',
                question : <>¿Cómo solicito los estudios de laboratorio?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡No te preocupes, nos encargamos nosotros! Solo debes comunicarte con nuestro equipo médico a través de la App {textAsistensi} RD o vía telefónica al (809) 547-7007. La solicitud la hará uno de nuestros médicos cuando seas atendido. Sólo ellos podrán realizar la solicitud de los exámenes de laboratorio que están cubiertos dentro de tu plan.
                    </p>
                </div>
            },
            {
                number : '20',
                question : <>¿A qué laboratorio puedo ir a realizarme los exámenes?</>,
                answer :								
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Una vez hayan sido coordinados por nuestros médicos, estos te indicarán el laboratorio al cual podras asistir. <br/>
                        En nuestra red contamos con los servicios de: Amadita Laboratorio Clínico, Referencia Laboratorio Clínico, Laboratorio Clínico Puerto Plata, Laboratorio Clínico Analisa, Laboratorio Clínico Sireny, entre otros.
                    </p>
                </div>
            },
            {
                number : '21',
                question : <>¿Mi servicio incluye la interpretación de estudios de laboratorio?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Cuando sean emitidos los resultados de los estudios de laboratorio, nuestro equipo médico brindará la interpretación de los mismos e incluso, podrás recibir un diagnóstico e indicaciones.
                    </p>
                </div>
            },
            {
                number : '22',
                question : <>¿Qué ofrece el servicio de entrega o recolección de medicamentos?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El servicio de cobertura de medicamentos te permitirá recibir 7 días de tratamiento recetados por nuestros médicos a raíz de una emergencia o urgencia médica. Nuestros médicos de cabecera virtual coordinarán contigo para que retires los medicamentos en la farmacia más cercana a ti.
                    </p>
                </div>
            },
            {
                number : '23',
                question : <>¿Existe algún plazo de espera para acceder al servicio de Plan de medicamentos?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Nuestros plazos de espera son muy cortos. Tendrás acceso a la cobertura de medicamentos, una vez confirmada la afiliación, en tan solo 15 días.
                    </p>
                </div>
            },
            {
                number : '24',
                question : <>¿Qué condicionantes tiene el servicio de entrega o recolección de medicamentos?</>,
                answer :								
                <div className="flex flex-col px-2">
                    <ul className={listClasses}>
                        <li>Recibirán o podrán recolectar medicamentos todo beneficiario que haya sido recetado por algún médico {textAsistensi} o un médico externo, posterior a una atención médica domiciliaria gestionada por {textAsistensi};</li>
                        <li>En caso de contar con una receta por parte de un médico externo, deberás enviar la misma a través del correo electrónico: medicord1@asistensi.com;</li>
                        <li>Los únicos medicamentos a ser enviados o recolectados serán los que se encuentran dentro de nuestro cuadro base, el cual fue elaborado para el tratamiento de enfermedades agudas;</li>
                        <li>No se incluyen, ni se recetan medicamentos controlados y/o para enfermedades crónico-degenerativas;</li>
                        <li>El límite de cantidades a recibir o recolectar es suficiente para cubrir hasta un máximo de siete días continuos de tratamiento por evento;</li>
                        <li>Se hará el envío o recolección de medicamentos una vez, por evento al año.</li>
                    </ul>
            </div>
            },
            {
                number : '25',
                question : <>¿Me podrían compartir el cuadro base de medicamentos al cual tengo acceso?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className="text-gray-800 text-base text-justify leading-relaxed mt-2">
                    Listado incluido en términos y condiciones
                    </p>
                </div>
            },
            {
                number : '26',
                question : <>¿En dónde puedo recolectar los medicamentos recetados?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className="text-gray-800 text-base text-justify leading-relaxed mt-2">
                        La recolección* de los medicamentos la podrás realizar en la red de Farmacias Carol y Farmacias Los Hidalgos, con previa coordinación por el equipo de {textAsistensi}.
                    </p>
                </div>
            },
            {
                number : '27',
                question : <>¿Qué necesito para poder recolectar mis medicamentos en Farmacias Carol y Farmacias Los Hidalgos?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Para recolectar los medicamentos en una sucursal de Farmacias Carol o Los Hidalgos, deberás haber realizado previamente la comunición indicada con uno de nuestros medicos de cabecera de {textAsistensi}, el emitira una autorización para que puedas presentarte en la sucursal mas cercana a ti.
                    </p>
                    <p className={paragraphClasses}>
                        Al presentarte a la sucursal deberás identificarte con tu carne de asitensi e identificación, para menores de edad la identificación del adulto responsable.
                    </p>
                </div>
            },
            {
                number : '28',
                question : <>¿En cuáles ciudades tiene alcance el servicio de {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Con {textAsistensi} recibirás nuestros servicios en las siguientes provincias: Distrito Nacional Santo Domingo, Santiago, Puerto Plata, La Altagracia, La Vega, Monseñor Nouel, San Cristóbal, San Pedro de Macorís, El Seíbo, La Romana, Espaillat, Samaná, Duarte, San Juan, Peravia, Sánchez Ramírez, Hermanas Mirabal, María Trinidad Sánchez, Valverde, Azua, Barahona y Hato Mayor.
                    </p>
                </div>
            },
            {
                number : '29',
                question : <>¿Por qué estas ciudades? ¿Cómo se ha determinado la cobertura?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Nos tomamos muy en serio el poder brindar y cumplir con todos los beneficios ofrecidos y contratados. Por eso, para realizar los mismos, hemos analizado variables en cada provincia que nos permiten identificar proveedores que ofrecezcan los estándares más altos de calidad en cada uno de los lugares donde operamos. 
                    </p>
                    <p className={paragraphClasses}>
                        En las ciudades y municipios que forman parte de la cobertura de {textAsistensi} contamos con:<br/>
                        Doctores certificados para realizar consultas médicas a domicilio;<br/>
                        Paramédicos y doctores entrenados para poder ejecutar traslados y atenciones ambulatorias;<br/>
                        Laboratorios clínicos para la realización de estudios solicitados; y<br/>
                        Centros de salud privados reconocidos que no pidan pagos en garantía, deducibles o coaseguros.
                    </p>
                    <p className={paragraphClasses}>
                        Nuestro compromiso contigo es llegar a más provincias, tratando de no comprometer nuestra oferta de valor.
                    </p>
                </div>
            },
            {
                number : '30',
                question : <>¿Cuántos planes maneja {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                    Actualmente, comercializamos dos planes de salud muy completos. Contamos con el plan {textAsistensi} y el plan {textAsistensi} plus.
                </p>
            </div>
            },
            {
                number : '31',
                question : <>¿Qué incluye el plan {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El seguro del plan {textAsistensi} cubre los gastos médicos derivados de una hospitalización por accidente y/o emergencia médica, contando con hasta RD$350,000 en suma asegurada, por evento al año. 
                    <br/><br/>
                        Además de incluir en su plan los siguiente servicios:
                    </p>
                    <ul className={listClasses}>
                        <li>Telemedicina ilimitada, 24 horas, los 365 días del año;</li>
                        <li>Atención médica domiciliaria ilimitada, 24 horas, los 365 días del año;</li>
                        <li>Traslados en ambulancia ilimitados, 24 horas, los 365 días del año;</li>
                        <li>Estudios de laboratorio: 2 perfiles de laboratorio clínicos al año;</li>
                        <li>Consultas con especialiastas: 2 consultas al año.</li>
                    </ul>
                </div>
            },
            {
                number : '32',
                question : <>¿Qué cubre el plan {textAsistensi} plus?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                El seguro del plan {textAsistensi} cubre los gastos médicos derivados de una hospitalización por accidente y/o emergencia médica, contando con hasta RD$600,000 en suma asegurada, por evento al año. 
                    <br/><br/>
                    Además de incluir en su plan los siguiente servicios:
                    </p>
                    <ul className={listClasses}>
                        <li>Telemedicina ilimitada, 24 horas, los 365 días del año;</li>
                        <li>Atención médica domiciliaria ilimitada, 24 horas, los 365 días del año;</li>
                        <li>Traslados en ambulancia ilimitados, 24 horas, los 365 días del año;</li>
                        <li>Estudios de laboratorio: 4 perfiles de laboratorio clínicos al año;</li>
                        <li>Consultas con especialiastas: 4 consultas al año;</li>
                        <li>Indemnización por enfermedades mayores.</li>
                    </ul>
                </div>
            },
            {
                number : '33',
                question : <>¿Quién emite la póliza de hospitalización y cirugía?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        De acuerdo a la normativa vigente en República Dominicana y las disposiciones legales del plan {textAsistensi}, la empresa aseguradora que presta y ampara la cobertura de emergencias médicas en hospitales privados es Humano Seguros. 
                    </p>
				</div>
            },
            {
                number : '34',
                question : <>¿Cuáles son las edades de contratación?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Como seguramente lo habrás leído, {textAsistensi} cuenta con la mejor admisibilidad del mercado. Aseguramos a personas desde los 0 hasta los 80 años, inclusive. Y la renovación está garantizada de por vida.
                    </p>
                </div>
            },
            {
                number : '35',
                question : <>¿Qué tipo de parentesco debo tener con la persona que quiero afiliar? </>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Hoy en día podemos asegurar a todos los miembros de tu familia e incluso a seres queridos (allegados).
                    </p>
                </div>
            },
            {
                number : '36',
                question : <>¿Cuál es la vigencia del plan?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Un año calendario desde la fecha de confirmación del pago de la afiliación, siempre y cuando los pagos sean honrados según la modalidad de pago seleccionada (mensual, trimestral, semestral o anual).
                    </p>
                </div>
            },
            {
                number : '37',
                question : <>¿Qué significa que la vigencia de los productos es de un año?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        La duración del contrato de {textAsistensi} y {textAsistensi} plus será de un año desde la confirmación del pago de la afiliación. Aún cuando brindamos frecuencias de pago (mensual, trimestral, semestral o anual), al contratar {textAsistensi} o {textAsistensi} plus el pagador asume el compromiso de realizar todos los pagos por el tiempo de duración del contrato, es decir, un año independientemente de la frecuencia de pago. 
                    </p>
                    <p className={paragraphClasses}>
                        En caso de impago, {textAsistensi} se reserva el derecho de reclamar el 100% del pago restante (e.g. reclamación del pago de parte desde {textAsistensi} o desde agencias de recobro o traspaso de datos a listas de morosidad).Únicamente se aceptará la anulación del contrato antes del cumplimiento de la vigencia del plan (anual), en casos de fallecimiento, previa facilitación del certificado de defunción; sin implicar ningún costo adicional a fecha corriente que indique el certificado.
                    </p>
                    <p className={paragraphClasses}>
                        Póngase en contacto con nosotros en inford@asistensi.com, para conocer con mayor detalle los términos y condiciones firmados en el momento de su contratación.
                    </p>
                </div>
            },
            {
                number : '38',
                question : <>Respecto a las renovaciones, ¿Cómo las manejan?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    La renovación de nuestros planes y seguros está garantizada de por vida, siempre y cuando se mantenga vigente la póliza.
                    </p>
                </div>
            },
            {
                number : '39',
                question : <>¿Cómo hago uso del plan y seguro contratado?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                ¡Muy sencillo! 
                </p>
                <p className={paragraphClasses}>
                Antes que nada, en caso de algún malestar físico, por favor contáctanos vía teléfonica al +1 (809) 547-7007 desde cualquier parte de la República Dominicana o por videollamada a través de nuestra App iOS o Android. Al comunicarse, un médico certificado realizará un "triaje" médico con el cual determinará la gravedad del malestar. Para el padecimiento, presentará indicaciones médicas y de ser necesario, se gestionará el servicio que se requiera.
                </p>
                <p className={paragraphClasses}>
                Sigue las indicaciones médicas y de necesitar ayuda extra podrás volver a contactarnos, siempre que lo necesites. 
                </p>
                <p className={paragraphClasses}>
                Recuerda que para poder utilizar cualquiera de los servicios necesitarás comunicarte con nosotros primero.
                </p>
            </div>
            },
            {
                number : '40',
                question : <>¿Cuál es el tiempo promedio de respuesta ante emergencias?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Nos esforzamos por atenderte lo antes posible, por eso, nuestro servicio de telemedicina es inmediato, las 24 horas del día los 7 días de la semana. En cuanto llames, serás atendido por uno de nuestros doctores.
                    </p>
                    <p className={paragraphClasses}>
                        En casos de emergencias, nuestras ambulancias son enviadas de forma inmediata por nuestro equipo médico, teniendo un tiempo de respuesta promedio de 30 minutos.
                    </p>
                    <p className={paragraphClasses}>
                        El 80% de los casos que requieren atención médica domiciliaria son atendidos en los primeros 45 minutos después de la llamada.
                    </p>
            </div>
            },
            {
                number : '41',
                question : <>¿De cuáles especialidades son los médicos dentro de la red?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Dentro de nuestra red contamos con médicos especialistas de todas las áreas de la medicina. Es posible que para ver a un médico especialista tengas que trasladarte a otra provincia.
                    </p>
                    <p className={paragraphClasses}>
                        En caso de solicitar una consulta con un médico especialista, tu médico de telemedicina coordinará tu visita y te dará seguimiento posterior a tu cita.
                    </p>
                    <p className={paragraphClasses}>
                        Los estudios especiales que resulten de la consulta con especialistas no tienen cobertura por parte de {textAsistensi}, pero tu médico telemedicina podrá recomendarte algunos centros donde los afiliados de {textAsistensi} reciben hasta un 10% de descuento en estudios especiales.
                    </p>
                </div>
            },
            {
                number : '42',
                question : <>¿Qué incluye el seguro funerario?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                    Cubre los servicios relacionados con el fallecimiento de la persona asegurada, hasta la suma asegurada contratada (RD$200,000.00). Pueden optar por la indemnización total o pueden utilizar los servicios de Prebea para los gastos fúnebres.
                </p>
                <p className={paragraphClasses}>
                    Este servicio incluye: gestión de la documentación, servicio de notificación telefónica, funeraria de su elección, traslado hacia la funeraria, capilla para el velatorio, coordinación de servicios religiosos, carroza fúnebre, cosmetizacion, ataúd o cremación, arreglo floral, recordatorios, servicio de café, libro de visitas, publicación de esquela en prensa, nicho en cementerio de su elección y lápida. 
                </p>
                <p className={paragraphClasses}>
                    *Disponible para beneficiarios residentes en Republica Dominicana y que en el momento de la afiliación tengan entre 16 y 69 años de edad.
                </p>
            </div>
            },
        ],
    },
    {
        title: <>Indemnización por enfermedades mayores</> ,
        questions : [
            {
                number : '43',
                question : <>¿Qué es el beneficio de indemnización por enfermedades mayores?</>,
                answer :
                <div className="flex flex-col px-2">
                <p className={paragraphClasses}>
                    Protección económica ante el diagnóstico (por primera vez) de una de las siguientes enfermedades o condiciones de alto costo:
                </p>
                <p className={paragraphClasses}>
                    Infarto al Miocardio, Cirugía de Puente Aortocoronario –bypass, Accidente Vascular Cerebral –AVC, Neurocirugía, Cáncer, Síndrome de Inmunodeficiencia Adquirida, Insuficiencia Renal Crónica, Trasplante de Órgano Mayor, Politraumatismo, Quemaduras Múltiples, Esclerosis Múltiple, Parálisis, Ceguera. 
                </p>
                </div>
            },
            {
                number : '44',
                question : <>¿Están cubiertas las prexistencias en este beneficio?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        No. Están excluidas permanentemente todas las prexistencias.
                    </p>
                </div>
            },
            {
                number : '45',
                question : <>¿Cuánto es el monto de cobertura?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    El monto de cobertura es de RD$400,000. 
                    </p>
                </div>
            },
            {
                number : '46',
                question : <>¿Qué pasa si el afiliado fallece antes de recibir la indemnización?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Este es un beneficio que solo se paga al titular en vida. Por tanto, perderia la cobertura en caso de fallecimiento.
                    </p>
                </div>
            },
            {
                number : '47',
                question : <>¿Qué tiempo tiene el afiliado para someter la solicitud de indemnización?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Luego de diagnosticado el evento, tendrá 2 años para someter la solicitud, por escrito.
                    </p>
                </div>
            },
            {
                number : '48',
                question : <>¿Cuáles son las vias para someter esta solicitud?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        A través de nuestro departamento de Servicio al cliente via telefónica o via correo: suscripcionrd@asistensi.com o por nuestra App {textAsistensi} RD.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>Plazos de espera</> ,
        questions : [
            {
                number : '49',
                question : <>¿Existe algún plazo para hacer uso de los servicios? </>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Nuestros plazos de espera son muy cortos, porque nuestro compromiso es cuidarte en todo momento. Tendrás acceso a nuestros servicios, una vez confirmada la afiliación, en tan solo:
                    </p>
                    <p className={paragraphClasses}>
                    24 horas para:<br/>
                    Telemedicina
                    </p>
                    <p className={paragraphClasses}>
                    15 días para:<br/>
                    Atención médica domiciliaria<br/>
                    Traslados en ambulancia<br/>
                    Cobertura para emergencias médicas en centros de salud<br/>
                    Pruebas de laboratorios clínicos, previamente prescritos por uno de nuestros médicos<br/>
                    Segunda opinión médica<br/>
                    Lectura de exámenes médicos<br/>
                    Plan Funerario *En caso de fallecer a causa de una prexistencia, el periodo de espera es de 2 años<br/>
                    Seguro de vida *En caso de fallecer a causa de una prexistencia, el periodo de espera es de 2 años
                    </p>
                    <p className={paragraphClasses}>
                    60 días para:<br/>
                    Consultas con médicos especialistas
                    </p>
                    <p className={paragraphClasses}>
                    12 meses para:<br/>
                    Indemnización por enfermedades mayores
                    </p>
                </div>
            },
            {
                number : '50',
                question : <>¿Los plazos de espera aplican nuevamente si aumenta el monto de la cobertura para hospitalización y cirugía de emergencia? </>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Sí. En caso de realizar un cambio de plan con una cobertura mayor, el afiliado deberá esperar 15 días para hacer efectivo el nuevo monto de cobertura.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>Cobertura de hospitalización en hospitales privados</> ,
        questions : [
            {
                number : '51',
                question : <>Si estoy ante una emergencia médica, ¿qué debo de hacer? </>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Contactárnos vía teléfonica al +1(809) 547-7007 desde cualquier parte de la República Dominicana o por videollamada a través de nuestra App {textAsistensi} RD. 
                    </p>
                    <p className={paragraphClasses}>
                    Si es una emergencia grave como, por ejemplo: accidentes graves, inconsciencia o dolor torácico sugestivo de infarto al miocardio, puedes solicitar el traslado en ambulancia a un centro de salud de la red y nuestro equipo velará porque recibas atención médica profesional en el camino.
                    </p>
                    <p className={paragraphClasses}>
                    En caso de no poder esperar la ambulancia, podrás trasladarte por tus propios medios al centro de salud, contactándonos mientras te diriges, para garantizar que al llegar tu cobertura de emergencias médicas esté activa y evitar una amonestación. 
                    </p>
                </div>
            },
            {
                number : '52',
                question : <>Si se requiere hospitalización ¿tengo que pagar algo extra?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En {textAsistensi} queremos que por lo único que tengas que preocuparte sea por recuperarte. Estés donde estés, cuidaremos de tu bolsillo. Para ayudarte con esto, y gracias al respaldo de nuestros socios comerciales, hemos logrado lo que nadie había podido lograr en el mercado:
                    </p>
                    <ul className={listClasses}>
                        <li>Un seguro que no pide garantías (depósitos, "vouchers abiertos" o el tener que dejar tarjetas de crédito/débito para ingresar a establecimientos de salud);</li>
                        <li>Sin pagos relacionados a deducibles;</li>
                        <li>Sin pagos relacionados a coaseguros; y</li>
                        <li>Manejando la modalidad de “pago directo”. Pago de aseguradora &lt;&gt; hospital o por medio de reembolso.</li>
                    </ul>
                    <p className={paragraphClasses}>
                        Recuerda que: antes de acudir a un hospital privado de nuestra Red {textAsistensi}  y en caso de algún malestar físico, por favor contactarse con nosotros vía teléfonica o por videollamada a través de nuestra App iOS o Android.
                    </p>
                </div>
            },
            {
                number : '53',
                question : <>El punto anterior, ¿aplica para siniestros y hospitalizaciones menores de 24 horas?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    ¡Correcto! En {textAsistensi}, una de nuestras propuestas de valor es intentar que no tengas que realizar ni un sólo pago al llegar al hospital privado de nuestra red.
                    </p>
                    <p className={paragraphClasses}>
                    Por ponerte un ejemplo: si alguna vez tuviste que ser hospitalizado por menos de 24 horas en alguna clínica de salud privada, seguramente te encontraste con la penosa situación de pagar la cuenta completa y luego solicitar un “reembolso” a tu aseguradora.
                    </p>
                    <p className={paragraphClasses}>
                    Nuestra intención es que no tengas que volver a solicitar un reembolso. Nosotros estaremos a tu lado y del de tu familia para acompañarlos en todos los procesos administrativos relacionados a la hospitalización.
                    </p>
                </div>
            },
            {
                number : '54',
                question : <>¿Qué significa modalidad de pago directo?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        La modalidad de pago directo básicamente refiere a que la aseguradora tratará cuestiones administrativas y de pago directamente con el hospital que atendió la situación de salud.
                    </p>
                    <p className={paragraphClasses}>
                        Tradicionalmente esta funcionalidad existe en los seguros de gastos médicos mayores y en situaciones de salud que llevan al beneficiario a hospitalizarse por más de 24 horas.
                    </p>
                    <p className={paragraphClasses}>
                        En {textAsistensi}, estamos rompiendo paradigmas y ofrecemos esta modalidad para percances que pueden llevar al cliente a estar en un hospital privado por menos de 24 horas.
                    </p>
                </div>
            },
            {
                number : '55',
                question : <>¿Existe algún tipo de penalización por no avisarle a {textAsistensi} y acudir a un hospital privado por cuenta propia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Sí, en caso de realizar dicha acción, es posible que el cliente encuentre algún punto de fricción en el proceso de admisión al hospital privado. Además, se le cobrará un copago del 20% del total de la cuenta, como penalización por no seguir las reglas del modelo.
                    </p><p className={paragraphClasses}>
                        Para una mejor gestión y atención de la emergencia, recomendamos siempre contactarnos primero vía teléfonica al +1(809) 557-7007 desde cualquier parte de la República Dominicana o por videollamada a través de nuestra App iOS o Android.
                    </p>
                </div>
            },
            {
                number : '56',
                question : <>¿Cuáles patologías y/o condiciones limitan la posibilidad de acceder a la cobertura de emergencias en centros de salud?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En {textAsistensi} queremos cuidar la salud de todos los dominicanos.
                    <br/><br/>
                        Puedes contratar nuestros servicios de atención médica inmediata sin importar tu edad y condición de salud.
                    <br/><br/>
                        Sin embargo, para tener cobertura de emergencias médicas en centros de salud debes gozar de buena salud, tener un índice de masa corporal (IMC) entre 18.5 y 35, y no padecer (o haber padecido) de:
                    <br/><br/>
                        Cardiopatía isquémica<br/>
                        Angina de pecho<br/>
                        Infarto al miocardio<br/>
                        Insuficiencia cardíaca<br/>
                        Hipertensión arterial sin tratamiento<br/>
                        Accidente Cerebro Vascular (ACV)<br/>
                        Ataques de isquemia cerebral<br/>
                        Aneurisma<br/>
                        Enfermedad Pulmonar Obstructiva Crónica (EPOC)<br/>
                        Insuficiencia renal crónica<br/>
                        Cáncer<br/>
                        Lupus<br/>
                        Esclerosis múltiple<br/>
                        Enfermedades congénitas, tales como: labio leporino y paladar hendido, síndrome de down, estenosis valvular aórtica, comunicación interventricular, estrechamiento del conducto aórtico, conducto arterial persistente, tetralogía de fallot, tronco arterial común, comunicación interauricular, conexión venosa pulmonar anómala, síndrome de Goldenhar, síndrome de Helweg –Larsen, síndrome de Treacher Collins, síndrome de Waardenburg, síndrome de Usher, síndrome de Alport, síndrome Alstrom, soplos, espina bífida, pie zambo, enfermedad de Tay-Sachs, entre otras.<br/>
                        Alteraciones de salud y/o enfermedades prexistentes (conocidas o desconocidas)
                    </p>
                </div>
            },
            {
                number : '57',
                question : <>¿Cuál es la red de proveedores de centros de salud?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        La cobertura de emergencias médicas en centros de salud está amparada por Humano Seguros y puedes usar cualquiera de los 
                        centros de salud de la red. Puedes revisar los centros de salud disponibles <a href="https://asistensi.s3.amazonaws.com/FAQS/Clinicas+con+cobertura+plan+asistensi.pdf" target="_blank" rel="noreferrer" ><u>aquí</u></a>.
                    </p>
                </div>
            },
            {
                number : '58',
                question : <>¿El monto de la cobertura para emergencias se agota en la medida que se utiliza, o es por patología por año?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El monto de la cobertura para emergencias médicas es por caso, por año. Es decir, puedes utilizarla múltiples veces para distintas emergencias. Todo esto con la finalidad de poder cuidar tu salud todas las veces que nos necesites.
                    </p>
                </div>
            },
            {
                number : '59',
                question : <>Si ya estoy afiliado a un seguro de salud, ¿puedo contratar un plan {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Por supuesto, puedes afiliarte y gozar de los beneficios de {textAsistensi} aún cuando tengas otra póliza de salud. <br/>
                        En caso de que desees utilizar tu plan de {textAsistensi} como complementario, será posible si tienes contratado una póliza de Humano Seguros
                    </p>
                </div>
            },
            {
                number : '60',
                question : <>¿Cuáles son las patologías consideradas bajo gastos médicos mayores?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Las enfermedades cubiertas por gastos médicos mayores son: enfermedades neurológicas y neuroquirúrgicas (incluyendo accidentes cerebro vasculares), tratamiento médico quirúrgico para el paciente con politraumatismo, quemaduras que requieren cuidados especiales y desórdenes infecciosos (septicemia).
                    <br/>
                        Esta cobertura será otorgada siempre y cuando el beneficiario no padezca alguna preexistencia relacionada con las enfermedades anteriormente mencionadas.
                    </p>
                </div>
            },
            {
                number : '61',
                question : <>¿Cuál es el monto de la cobertura de los seguros que ofrecen?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Dependiendo del plan que elijas. Con el plan {textAsistensi}, la cobertura es de RD$350,000.00 por caso por año y con el plan {textAsistensi} Plus, hasta $600,000.00 por caso por año.
                    </p>
                </div>
            },
            {
                number : '62',
                question : <>¿Puedo contactar directamente a Humano Seguros para solicitar la activación de la cobertura de mi plan {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Para solicitar la activación de la cobertura de Humano Seguros de tu plan {textAsistensi}, es indispensable nos contactes primero a través de nuestra APP {textAsistensi} RD o llamándonos al +1 (809) 547-7007, donde uno de nuestros médicos te brindará atención y orientación. Si así lo determina, nuestro médico activará los servicios de atención médica domiciliaria, traslados en ambulancia y la cobertura de emergencias médicas en centros de salud. Si no nos contactas primero, tu cobertura podrá ser negada.
                    </p>
                </div>
            }
        ]
    },
    {
        title: <>Preexistencia y buena salud</> ,
        questions : [
            {
                number : '63',
                question : <>¿{textAsistensi} afilia a personas con preexistencias y enfermedades crónico-degenerativas?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        {textAsistensi}  puede ofercer sus planes de salud a personas con enfermedades crónico-degenerativas como lo son la Diabetes mellitus tipo 2 o hipertensión arterial sistémica. Sin embargo, algunas enfermedades están excluídas, por ejemplo las enfermedades congénitas, etc.
                    </p><p className={paragraphClasses}>
                        En nuestra búsqueda por democratizar el acceso a salud en el país, hemos conseguido lo que muy pocos habían podido en el pasado. Hoy, le damos la posibilidad a los clientes que compren el plan {textAsistensi} y tengan Diabetes mellitus tipo 2 o Hipertensión arterial sistémica puedan tener acceso a un seguro médico. De igual forma, los clientes que tengan hipertensión y compren el plan plus podrán tener cobertura de hospitalización.
                    </p><p className={paragraphClasses}>
                    <i>**Las enfermedades crónico-degenerativas deberán estar controladas y se le podrán solicitar ciertas pruebas al cliente que avale el estado actual de la condición.<br/>
                        Las enfermedades crónico-degenerativas estarán excluidas en la cobertura de hospitalización y cirugía de emergencia.</i>
                    </p>
                </div>
            },
            {
                number : '64',
                question : <>¿Qué es una preexistencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Es una condición de salud preexistente a cualquier enfermedad, lesión corporal, condición de salud y/o la presencia de síntomas y/o signos que padece una persona previo a la contratación de un plan de salud.
                    <br/><br/>
                        Esto incluye, pero no está limitado, a cualquier condición sobre la cual una persona:
                    <br/><br/>
                        Tiene síntomas y/o signos, aún sin conocer el diagnóstico relacionado a estos.<br/>
                        Tuvo advertencia médica o consultó a un médico.<br/>
                        Recibió tratamiento médico, servicios o suministros médicos.<br/>
                        Se ha practicado o le recomendaron exámenes para el diagnóstico pertinente.<br/>
                        Toma medicamentos recetados o recomendados.<br/>
                        Asistió a un médico para diagnóstico, cuidado o tratamiento.
                    <br/><br/>
                    Nuestros planes no cubren cualquier situación que resulte de una preexistencia, y algunas preexistencias pueden limitar la contratación la cobertura para emergencias médicas en centros de salud como por ejemplo, pero no limitado a: cardiopatía isquémica, angina de pecho, infarto al miocardio, insuficiencia cardíaca, hipertensión arterial sin tratamiento, ACV, ataques de isquemia cerebral, aneurisma, EPOC (Enfermedad Pulmonar Obstructiva Crónica), insuficiencia renal crónica, cáncer, lupus, esclerosis múltiple y condiciones congénitas. Ahora bien, para algunas de estas patologías preexistentes y posterior a una evaluación individual de tu caso, puedes contratar nuestros planes excluyendo la cobertura para emergencias médicas en centros de salud para situaciones que resulten de dichas preexistencias.
                    <br/><br/>
                        En {textAsistensi} puedes contratar con las condiciones pre-existentes de: hipertensión arterial y diabetes mellitus si tomas el tratamiento regular y demuestras que tu condición se encuentra controlada.
                    <br/><br/>
                        Si tienes alguna duda en relación a si padeces de alguna condición pre-existente o sobre la cobertura de emergencias médicas en centro de salud, nuestro equipo está disponible para evaluar tu caso y responder tus inquietudes. Nos puedes llamar al +1(809) 547 7007 o escribir a inford@asistensi.com.
                    </p>
                </div>
            },
            {
                number : '65',
                question : <>¿Qué significa "gozar de buena salud"?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Gozar de buena salud significa:
                    <br/><br/>
                        No presentar ninguna alteración de la salud (enfermedad o condición). Ni padecer alguna condición que origine reducción de la capacidad funcional (imposibilidad que limite o impida el desempeño motor de la persona afectada) o mental (deterioro de capacidades neurológicas).
                    <br/><br/>
                        No requerir tratamiento médico y/o intervención quirúrgica en el futuro por alguna condición pre-existente.
                    <br/><br/>
                        No haber padecido ninguna de las siguientes enfermedades, pero no limitado a: cardiopatía isquémica, angina de pecho, infarto al miocardio, insuficiencia cardíaca, hipertensión arterial sin tratamiento, ACV, ataques de isquemia cerebral, aneurisma, EPOC (Enfermedad Pulmonar Obstructiva Crónica), insuficiencia renal crónica, cáncer, lupus y esclerosis múltiple y/o enfermedades congénitas.
                    <br/><br/>
                        Tener un índice de masa corporal (IMC) entre 18.5 y 35.
                    <br/><br/>
                        Sí son admisibles para la cobertura de emergencias médicas en centros de salud de la red, las personas con enfermedades crónicas controladas como hipertensión arterial y diabetes mellitus, sin embargo, emergencias médicas causadas por estas enfermedades quedan excluidas de cobertura.
                    </p>
                </div>
            },
            {
                number : '66',
                question : <>¿Qué significa reducción de la capacidad funcional?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Imposibilidad que limite o impida el desempeño motor o de la vida normal de una persona en la ejecución de las actividades de la vida diaria, sin la necesidad de asistencia o supervisión (por ejemplo, estar "encamado").
                    </p>
                </div>
            },
            {
                number : '67',
                question : <>¿Qué es una patología aguda?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Enfermedad o condición de salud que presenta sintomatología de aparición repentina e inesperada que hayan iniciado en un tiempo no mayor a 72 horas y cuyos síntomas pueden poner en riesgo la vida, requiriendo atención médica inmediata.
                    </p>
                </div>
            },
            {
                number : '68',
                question : <>¿Qué cobertura tendré si padezco alguna enfermedad crónica o preexistencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Con {textAsistensi} estarás cuidado sin importar tu edad y aún si sufres de una enfermedad crónica que esté controlada; ya que recibirás de forma ilimitada nuestros servicios de telemedicina, atención médica domiciliaria, traslado en ambulancias, consultas con especialistas y pruebas de laboratorios clínicos.
                    </p>
                </div>
            },
            {
                number : '69',
                question : <>¿Una persona con hipertensión arterial y diabetes mellitus puede afiliarse en {textAsistensi}?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Si sufres de una enfermedad crónica y tomas tu tratamiento para mantener controlada la enfermedad, disfrutarás de todos nuestros beneficios, sin embargo, queda excluida la cobertura de emergencias médicas en centros de salud aquellas emergencias médicas que surjan a raíz de alguna de estas condiciones preexistentes.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>Botón de Asistencia</> ,
        questions : [
            {
                number : '70',
                question : <>¿Qué es el botón de asistencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El botón de asistencia médica brinda protección inmediata 24/7 con un brazalete portátil de última generación donde el afiliado podrá solicitar asistencia médica con tan solo presionar un botón. Este brazalete también permite ubicar la locación exacta de la persona gracias a su sistema de localización GPS.
                    <br/><br/>
                        En caso de una emergencia o urgencia médica, el beneficiario sólo tendrá que presionar el botón SOS y un médico de {textAsistensi} estará disponible para atenderlo; sin necesidad de llamar o utilizar la APP.
                    <br/><br/>
                        Este es un beneficio adicional que puedes contratar con cualquiera de nuestros planes.
                    </p>
                    <p className={paragraphClasses}></p>
                </div>
            },
            {
                number : '71',
                question : <>¿Se puede solicitar los servicios médicos de {textAsistensi} a través del botón de asistencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Sí. Al momento de presentarse una emergencia o urgencia médica, el beneficiario, al presionar el botón, será evaluado por un médico de cabecera virtual de {textAsistensi} para brindar atención médica inmediata. También podrá coordinar envío de recetas, atención médica domiciliaria, pruebas de laboratorios clínicos, traslados en ambulancias, consultas con especialistas y de ser necesario, prestar apoyo en la admisión a clínicas afiliadas activando la cobertura con Humano Seguros.
                    </p>
                </div>
            },
            {
                number : '72',
                question : <>Si contraté el servicio de botón de asistencia, ¿soy el propietario del dispositivo?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    No, el botón de asistencia es un beneficio que ofrece {textAsistensi} y la propiedad del equipo es de la empresa. Si el beneficiario decide no renovar, una vez terminada la vigencia del servicio, debe devolver el equipo.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>COVID - 19</> ,
        questions : [
            {
                number : '73',
                question : <>¿Los planes {textAsistensi} cubren COVID-19?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El plan {textAsistensi} cubre los costos asociados a la detección y tratamiento para la enfermedad de COVID-19 vía: telemedicina, monitoreo constante, acompañamiento médico remoto continuo desde el momento del primer síntoma, traslados en ambulancias, pruebas de laboratorios clínicos, consultas con especialistas y cobertura de emergencias en las mejores clínicas del país.
                    </p>
                    <p className={paragraphClasses}>
                        La prueba PCR para el diagnóstico de COVID-19, estará cubierta por tu plan siempre y cuando la prueba se realice en un centro de salud luego de que hayas sido hospitalizado con diagnóstico base de COVID-19.
                    </p>
                </div>
            },
            {
                number : '74',
                question : <>¿Cómo es el acompañamiento remoto en casos de COVID-19?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Desde que tienes el primer síntoma, uno de nuestros médicos va a monitorear tu caso a través de nuestro servicio de telemedicina, brindándote orientación médica telefónica las 24 horas del día, 7 días a la semana y de ser necesario nuestros médicos se trasladarán a donde te encuentres para darte atención médica domiciliaria. Asi como la coordinación de cualquier otro servicio que necesites.
                    </p>
                </div>
            },
            {
                number : '75',
                question : <>¿Hacen la prueba para detectar COVID-19?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Los planes de {textAsistensi} cubre el costo de la prueba PCR para el diagnóstico de COVID-19, siempre y cuando la prueba se realice en un centro de salud luego de que el paciente haya sido hospitalizado con diagnóstico base de COVID-19.
                    </p>
                </div>
            },
            {
                number : '76',
                question : <>¿Cubren medicamentos para COVID?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Mientras el afiliado esté hospitalizado a causa del COVID-19 todos los medicamentos necesarios para tratar la enfermedad están cubiertos.
                    <br/><br/>
                        El plan de medicamentos para emergencias médicas que ofrece {textAsistensi} cubre la mayoría de los medicamentos que se requieren para tratar de forma ambulatoria el virus del COVID-19, sin embargo los antivirales no tienen cobertura de forma ambulatoria. Puedes agregar el plan de medicamentos a cualquiera de los planes de seguro de {textAsistensi}. Para conocer más acerca de nuestro plan de medicamentos ve a la pregunta 31.
                    </p>
                </div>
            }
        ]
    },
    {
        title: <>Contratación y suscripción</> ,
        questions : [
            {
                number : '77',
                question : <>¿Dónde puedo encontrar los costos de los planes y seguros?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Puedes realizar una cotización en cuestión de segundos en nuestra sección de inicio haciendo clic en "Quiero cotizar". También puedes llamarnos al +1 (809) 547-7007 extensión 2, donde uno de nuestros asesores comerciales te asistirá. 
                    </p>
                </div>
            },
            {
                number : '78',
                question : <>¿Cómo se realiza la contratación y suscripción al producto?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Muy fácil! La contratación y suscripción se realiza de manera 100% digital y en línea a través del sitio web asistensi.com.do. 
                    </p><p className={paragraphClasses}>
                        Para realizar el proceso, sólo deberás dar click a “Afiliarse ahora”, seguir los pasos correspondientes y llenar la información solicitada. Derivado de las respuestas, se considerará la aceptación de solicitantes con algún antecedente médico, excluyendo algunas enfermedades y urgencias relacionadas con la enfermedad declarada. 
                    </p><p className={paragraphClasses}>
                        Recuerda que la contratación es inmediata y sólo requiere contestar cinco preguntas médicas de admisión. Finalmente, y para la misma, no será necesario realizar algún exámen médico previo. Se permitirá la contratación del plan y seguro {textAsistensi} a toda persona que cumpla con los parámetros establecidos de aceptación y afiliación impuestos por {textAsistensi} y Humano Seguros.
                    </p>
                </div>
            },
            {
                number : '79',
                question : <>¿Puedo cambiar de plan cuando lo desee? Es decir, pasar del plan {textAsistensi} al plan {textAsistensi} plus, y viceversa?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Desafortunadamente, no. Toda la contratación de planes y seguros de {textAsistensi} se manejan como negocio nuevo. El plan podrá ser modificado toda vez se cumpla con el mismo un año calendario.
                    </p>
                </div>
            },
            {
                number : '80',
                question : <>¿Los movimientos por cambios de información se verían aplicados en el cuadro de póliza emitido?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Los cambios efectuados podrán ser visualizados dentro de la cuenta abierta del usuario en el sitio web de {textAsistensi} y vía su aplicación móvil (APP).
                    <br/><br/>
                        También, y de solicitarlo, podremos realizar los ajustes correspondientes al cuadro de póliza emitido. Para esta acción necesitaríamos que se pusieran en contacto a través del correo electrónico: inford@asistensi.com.
                    </p>
                </div>
            },
        ]
    },
    {
        title: <>Pagos y cobros</> ,
        questions : [
            {
                number : '81',
                question : <>¿Qué métodos de pago tienen disponibles?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Ofrecemos una gama importante de opciones para poder realizar los pagos correspondientes a tu plan y seguro {textAsistensi}.
                    <br/><br/>
                        Actualmente aceptamos una gran variedad de metodos de pago para tu comodidad y seguridad: Tarjeta de débito o crédito internacionales, Zelle, Paypal, transferencias bancarias en USA, Europa, República Dominicana y Panamá, así como pago en efectivo en cualquiera de nuestras oficinas.
                    </p>
                </div>
            },
            {
                number : '82',
                question : <>¿Qué modalidades y frecuencia de pago ofrecen?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Los clientes de {textAsistensi} tienen la oportunidad de pagar de manera anual, semestral, trimestral y mensual. Mientras menos frecuente sea tu frecuencia de pago, más económico resultará adquirir el plan y seguro {textAsistensi}.
                    </p>
                </div>
            },
            {
                number : '83',
                question : <>¿En qué me beneficia pagar de contado mi plan?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Pagando y escogiendo la modalidad de pago “anual” tendrás la oportunidad de cuidar tu economía, ya que el costo total del plan será 10% menor que al de pagar bajo la modalidad de pago “mensual”, por ejemplo.
                    </p>
                </div>
            },
            {
                number : '84',
                question : <>¿Existen periodos de gracia en caso de que los pagos no sean anuales? Es decir, ¿qué pasa si me retraso con un pago?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Comprendemos que a veces ocurren situaciones que están fuera de nuestro control. Por ello, ofrecemos 30 días como período de gracia para los planes contratados con modalidad trimestral, semestral o anual para poder efectuar pagos subsiguientes. El cliente recibirá hasta 3 notificaciones recordando que el cobro de su plan y seguro no se ha podido realizar. Es importante tener en cuenta que durante dicho período, el plan {textAsistensi} no será suspendido pero sí deberá regularizar su situación administrativa para poder solicitar cualquiera de nuestros servicios.
                    <br/><br/>
                        Para todos estos casos y cualquier duda y comentario respecto a cobros, ponemos a disposición de nuestros clientes el correo electrónico: pagosrd@asistensi.com.
                    </p>
                </div>
            },
            {
                number : '85',
                question : <>¿Puedo pagar en moneda local?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Por supuesto! Aceptamos pagos en dólares americanos (USD) y pesos dominicanos (DOP).
                    <br/><br/>
                        Antes de realizar tu pago, por favor asegúrate de seleccionar la moneda que prefieres. Para cualquier duda o aclaración por favor contactanos a: inford@asistensi.com
                    </p>
				</div>
            },
            {
                number : '86',
                question : <> ¿Pago en efectivo en mensualidades?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Leíste bien! Puedes realizar los pagos con divisas en efectivo inclusive al escoger la frecuencia de pago mensual, a través de nuestras oficinas.
                    </p>
                </div>
            },
            {
                number : '87',
                question : <> ¿Cuándo tengo que reaizar el primer pago?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        El primer pago de tu plan {textAsistensi} tendrá que ser efectuado inmediatamente sea completado el proceso de afiliación digital o en caso de solicitarlo, a través de un asesor comercial de {textAsistensi}. Una vez recibido el mismo, y habiéndoselo informado al cliente, empezarán a contar los días relacionados a los períodos de espera para poder hacer uso de todos los beneficios y servicios que {textAsistensi} tiene para ofrecer.
                    </p>
                </div>
            },
            
        ]
    },
    {
        title: <>Dudas adicionales</> ,
        questions : [
            {
                number : '88',
                question : <> ¿Qué es una emergencia?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Una emergencia médica es una condición de carácter súbito y repentino, manifestada por síntomas agudos y severos que requieren de una atención inmediata, y que en caso de no recibir la atención médica necesaria y oportuna pueda poner en peligro la vida o la función de un órgano del paciente. La atención de las emergencias médicas con {textAsistensi} está incluida en la cobertura para emergencias médicas en centros de salud (con o sin el traslado de emergencia en ambulancias).
                    </p>
				</div>
            },
            {
                number : '89',
                question : <> ¿Qué es una urgencia médica?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Una urgencia médica es una situación que no pone en evidente peligro la vida ni ocasiona consecuencias graves para la persona, por lo que no amerita atención médica de manera repentina. La atención de las urgencias médicas con {textAsistensi} deben ser realizadas inicialmente a través de los servicios de médico de cabecera virtual y de atención médica domiciliaria, donde nuestro equipo médico decidirá si es necesario o no trasladar al paciente a un centro de salud para activar la cobertura de emergencias médicas.
                    </p>
                </div>
            },
            {
                number : '90',
                question : <> ¿Las coberturas que ofrecen son suficientes para cubrir los gastos de emergencia que se puedan presentar?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Por supuesto! De acuerdo a múltiples estudios, análisis y nuestra experiencia han demostrado que nuestros montos de cobertura alcanzan para cubrir el 95% de las urgencias o emergencias médicas.
                    </p>
                </div>
            },
            {
                number : '91',
                question : <> ¿Cómo los puedo contactar?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        En pro de tener una comunicación fluida y transparente con todos nuestros beneficiarios y clientes potenciales, contamos con una amplia variedad de canales y vías de comunicación disponibles.
                    <br/><br/>
                        Nuestros canales de comunicación son los siguientes:
                    <br/><br/>
                        Página de contacto en www.asistensi.com.do<br/>
                        Por teléfono desde República Dominicana: +1 (809) 547-7007<br/>
                        Por teléfono desde Estados Unidos: +1 (917) 909-5661<br/>
                        Por teléfono desde España: +34 (911) 231 079<br/>
                        Desde nuestra aplicación móvil (APP) {textAsistensi} RD<br/>
                        Para temas operativos (relacionados a cuenta, dudas generales, etc.): inford@asistensi.com<br/>
                        Para temas de pagos: pagosrd@asistensi.com<br/>
                        En redes sociales como: asistensi.rd (Instagram) y asistensi.rd (Facebook)<br/>
                        En caso de tener alguna sugerencia nos encantaría escucharla ya que la calidad y experiencia de nuestros beneficios y servicios es lo más importante para nosotros.
                    </p>
                </div>
            },
            {
                number : '92',
                question : <> Estamos interesados en explorar una alianza estratégica con {textAsistensi}, ¿quién me puede apoyar?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Nos honra la consideración e interés! En {textAsistensi} siempre estamos abiertos a explorar colaboraciones que sumen a la ya atractiva propuesta de valor de nuestros beneficiarios.
                    <br/><br/>
                        Para abrir la comunicación y buscar entablar una relación comercial, por favor escribir a inford@asistensi.com
                    </p>
                </div>
            },
            {
                number : '93',
                question : <> ¿Cubren maternidad?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        Desafortunadamente, no. Estamos trabajando fuertemente para que este servicio este incluido próximamente.
                    </p>
                </div>
            },
            {
                number : '94',
                question : <> Como contratante, ¿puedo ver los servicios que usaron mis familiares?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                        ¡Claro! A través de nuestra App {textAsistensi} RD (disponible para iOS y Android) se puede acceder al historial del beneficiario y a los servicios utilizados.
                    </p>
                </div>
            },
            {
                number : '95',
                question : <> ¿Quiénes deben descargar la App?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Tanto el contratante como los beneficiarios deben descargar el app para gozar de todos los beneficios de {textAsistensi}, según el perfil.
                    </p>
                </div>
            },
            {
                number : '96',
                question : <> ¿A quiénes puedo asegurar?</>,
                answer :
                <div className="flex flex-col px-2">
                    <p className={paragraphClasses}>
                    Con {textAsistensi} puedes afiliar a un ser querido o cualquier familiar que desees. (Pueden ser tus papás, abuelitos, hijos, cónyugue, familiar político, amigo, etc.)
                    </p>
                </div>
            },
        ]
    },
]